import { formatArPhoneDisplay } from '@shared/phone';
import { buildCsvFromRows } from '../../shared/csv-core/infra/buildCsv';
import { formatCustomerCreditLimitLabel } from './customerCreditLimit';
import { isCustomerOverdue, getOverdueDays } from './customerDunning';
import type { CustomerAccountRow } from '../domain/customerTypes';

export function buildCustomerListCsv(params: {
  rows: CustomerAccountRow[];
  formatMoney: (n: number) => string;
}): string {
  const { rows, formatMoney } = params;
  // Sin columna `id` (UUID interno): el export es para personas, no para debug.
  const headers = [
    'nombre',
    'telefono',
    'cuit',
    'email',
    'direccion',
    'limite_credito',
    'saldo',
    'dias_vencido',
    'bloqueado',
    'notas',
  ];

  const dataLines = rows.map((c) => [
    c.name,
    c.phone ? formatArPhoneDisplay(c.phone) : '',
    c.cuit ?? '',
    c.email ?? '',
    c.address ?? '',
    formatCustomerCreditLimitLabel(c.creditLimit, formatMoney),
    formatMoney(c.balance),
    isCustomerOverdue(c) ? String(getOverdueDays(c) ?? 0) : '0',
    c.blocked ? 'si' : 'no',
    c.notes ?? '',
  ]);

  return buildCsvFromRows(headers, dataLines);
}
